'use client';

import { StoryblokImage } from '@/components/customFields/StoryblokImage';
import HeadlineField, { HeadlineTag } from '@/storyblok/wirfuersklima/functionalComponents/HeadlineField';
import ContentSection from '@/storyblok/wirfuersklima/functionalComponents/contentSection/ContentSection';
import type { SectionTextTwoImagesStoryblok } from '@/storyblok/wirfuersklima/types';
import type { AssetStoryblok as SbAssetStoryblok } from '@/types/component-types-sb';
import classNames from 'classnames';
import { Parallax } from 'react-scroll-parallax';
import { render } from 'storyblok-rich-text-react-renderer';

import classes from './SectionTextTwoImages.module.scss';

const SectionTextTwoImages: React.FC<{ blok: SectionTextTwoImagesStoryblok }> = ({ blok }) => {
  return (
    <ContentSection blok={blok} className={classes['section-text-two-images']} anchorId={blok.anchor_id}>
      <div className="grid-wrapper">
        <div className={classes['section-text-two-images__inner']}>
          <div className={classNames(classes['section-text-two-images__text'], 'text-block')}>
            <HeadlineField tag={HeadlineTag.H2} style={HeadlineTag.H2}>
              {blok.headline}
            </HeadlineField>
            {render(blok.text)}
          </div>
          <div className={classes['section-text-two-images__images']}>
            <Parallax className={classes['section-text-two-images__image']} translateY={['0px', '50px']}>
              <StoryblokImage image={blok.image_front as unknown as SbAssetStoryblok} aspectRatio={1} />
            </Parallax>

            <Parallax className={classes['section-text-two-images__image']} translateY={['-70px', '70px']}>
              <StoryblokImage image={blok.image_back as unknown as SbAssetStoryblok} aspectRatio={1} />
            </Parallax>
          </div>
        </div>
      </div>
    </ContentSection>
  );
};

export default SectionTextTwoImages;
